import { Route } from '@angular/router';
import { authGuard } from '@fy-web-2/core';

export const appRoutes: Route[] = [
  {
    path: 'login',
    loadChildren: () => import('@fy-web-2/feature-auth').then((m) => m.featureAuthRoutes),
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard.page').then((m) => m.DashboardPage),
    title: 'Dashboard',
  },
  {
    path: 'enquiries',
    canActivate: [authGuard],
    loadChildren: () => import('@fy-web-2/feature-enquiry').then((m) => m.featureEnquiryRoutes),
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found.page').then((m) => m.NotFoundPage),
    title: 'Not Found',
  },
];
